if (!customElements.get("component-product-formats")) {
  class ProductFormatsSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      if (this.swiper && typeof this.swiper.destroy === "function") {
        this.swiper.destroy(true, true);
      }
      this.swiper = null;
    }

    init() {
      if (typeof Swiper === "undefined") return;

      const swiperRoot = this.querySelector(".product-formats__swiper");
      if (!swiperRoot) return;

      const rawInitial = this.getAttribute("data-initial-slide");
      let initialSlide = 0;
      if (rawInitial != null && rawInitial !== "") {
        const parsed = parseInt(rawInitial, 10);
        if (Number.isFinite(parsed) && parsed >= 0) initialSlide = parsed;
      }

      // Swiper 4 breakpoints: narrow viewports match key 989 first (989 >= width); wider use root params.
      this.swiper = new Swiper(swiperRoot, {
        initialSlide,
        slidesPerView: 3,
        spaceBetween: 29,
        grabCursor: true,
        watchOverflow: true,
        breakpoints: {
          989: {
            slidesPerView: 1.7,
            spaceBetween: 12,
            centeredSlides: true,
            loop: true,
            loopedSlides: 3,
            watchOverflow: false,
          },
        },
      });
    }
  }

  customElements.define("component-product-formats", ProductFormatsSlider);
}
